import React, {useEffect, useState} from 'react'
import './header.scss'
import LanguageSwitcher from '../language-switcher/language-switcher'
import { useTranslation } from 'react-i18next'
import Hamburger from "./hamburger";
import MobileMenu from "./mobile-menu";


const Header = () => {
    const { t } = useTranslation()
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    useEffect(() => {
        if (isMenuOpen) {
            // Блокируем скролл
            document.body.style.overflow = 'hidden';
        } else {
            // Разблокируем скролл
            document.body.style.overflow = 'auto';
        }

        // Чистим эффект при размонтировании компонента
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMenuOpen]);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    // Обновляем ширину окна при изменении размеров
    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const toggleMenu = () => {
        if (windowWidth <= 986)
            setIsMenuOpen(!isMenuOpen)
    }


    return (
        <div className={`header container ${isMenuOpen ? 'active' : ''}`}>
            <div className='header__column' data-aos="fade-down">
                <div className='header__logo'>
                    <img width={150} src={process.env.REACT_APP_LOGO} alt=""/>
                </div>
                <LanguageSwitcher/>
                <div className='header__buttons'>
                    <a href={process.env.REACT_APP_LOGIN_LINK || "#"} rel="noreferrer" target="_blank" className='header__button button  button--transparent'>
                        {t('header.button.login')}
                    </a>
                    <a  href={process.env.REACT_APP_REGISTER_LINK || "#"} target="_blank" rel="noreferrer" className='header__button button '>
                        {t('header.button.register')}
                    </a>
                </div>


                <Hamburger isOpen={isMenuOpen} onClick={toggleMenu}/>
            </div>

            <div className='header__column' data-aos="fade-left">
                <div className='header__nav'>
                    <a href="#about" className='header__link' onClick={toggleMenu}>{t('header.link.about')}</a>
                    <a href="#price" className='header__link' onClick={toggleMenu}>{t('header.link.price')}</a>
                    <a href="#info" className='header__link' onClick={toggleMenu}>
                        {t('header.link.information')}
                    </a>
                    <a href="#trade" className='header__link' onClick={toggleMenu}>
                        {t('header.link.trade_view')}
                    </a>
                    <a href="#contact" className='header__link' onClick={toggleMenu}>
                        {t('header.link.contact_us')}
                    </a>
                </div>


            </div>
            <div className="header__mobile-bg"></div>
            {isMenuOpen && <MobileMenu toggleMenu={toggleMenu}/>}
        </div>
    )
}
export default Header
